<template>
  <div class="communications">
    <div class="row column-s align-center">
      <div class="title">COMUNICADOS</div>
      <div class="tab row">
        <div @click="tab = true" :class="tab ? 'active' : ''">Portal</div>
        <div @click="tab = false" :class="!tab ? 'active' : ''">
          Outros Canais
        </div>
      </div>
    </div>
    <div class="content">
      <CommunicationsPortal v-if="tab" />
      <CommunicationsSupporter v-if="!tab" />
    </div>
  </div>
</template>

<script>
import CommunicationsSupporter from "@/components/CommunicationsSupporter.vue";
import CommunicationsPortal from "@/components/CommunicationsPortal.vue";

export default {
  name: "Communications",
  components: {
    CommunicationsSupporter,
    CommunicationsPortal,
  },
  data() {
    return {
      tab: false,
    };
  },
  beforeMount() {},
  methods: {},
  mounted() {
    this.$parent.$children[0].changeMenu("communication");
  },
};
</script>

<style lang="scss" scoped>
@import "@/assets/scss/vars.scss";
.communications {
  padding: 42px 35px;
  @media (max-width: $small) {
    padding: 7px;
  }

  .title {
    font-size: 26px;
    font-weight: bold;
    color: $client-2;
    @media (max-width: $small) {
      margin-top: 38px;
      margin-bottom: 0px;
    }
  }
  .tab {
    padding: 5px 15px;
    color: $gray-9;
    font-weight: bold;
    div {
      border: 2px solid #ccc;
      border-bottom: none;
      padding: 14px 30px;
      border-radius: 19px 19px 0 0;
      cursor: pointer;
      &.active {
        background: #fff;
        color: $client-2;
      }
    }
  }
}
</style>